import { render, staticRenderFns } from "./f06.vue?vue&type=template&id=e77d1b7a&"
import script from "./f06.vue?vue&type=script&lang=js&"
export * from "./f06.vue?vue&type=script&lang=js&"
import style0 from "./f06.vue?vue&type=style&index=0&id=e77d1b7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports